<template>
  <div class="content--error">
    <MyHeader />

    <header class="content-header d-lg-none">
      <h1>Idea board</h1>
      <router-link :to="{name: 'AddIdea'}" class="button-icon-simple"><i class="icon-plus"></i></router-link>
    </header>

    <div class="error-body">
      <div class="error-content">
        <h1>We are sorry…</h1>
        <p>The page you’re trying to visit has restricted access. </p>
        <p class="error-code">Error code: 403</p>
        <router-link :to="{name: 'Login'}"  class="button-icon button--submit">Go home <i class="icon-arrow"></i></router-link>
      </div>
      <div class="error-image">
        <img src="../../assets/images/errors/Error-403.svg">
      </div>
    </div>
    <MyFooter />
  </div>
</template>

<script>
import MyHeader from '../../components/general/Header'
import MyFooter from '../../components/general/Footer'
export default {
  name: "AccessDenied",
  components: { MyHeader, MyFooter },
}
</script>

<style scoped>

</style>
